import React, { forwardRef } from "react";
import { withStyles } from "@material-ui/core";
import { fade } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";

const CustomButton = forwardRef((props, ref) => <Button ref={ref} {...props} variant="contained" />);

CustomButton.displayName = "MissionStartButton";

export default withStyles((theme) => ({
  root: {
    color: theme.palette.primary.main,
    backgroundColor: fade(theme.palette.primary.main, 0.08),
    borderRadius: 22,

    "&:hover": {
      backgroundColor: fade(theme.palette.primary.main, 0.1),
      boxShadow: "none",
    },
    boxShadow: "none",
    textTransform: "none",
    marginTop: theme.spacing(2),
  },
  contained: {
    "& .MuiButton-label": {
      fontWeight: 500,
      fontSize: 22,
      [theme.breakpoints.between(1024, 1320)]: {
        fontSize: 20,
      },
    },
    "&.Mui-disabled": {
      color: "#3D4853",
      backgroundColor: "#fff",
      border: "2px solid #C5C7C9",
    },
  },
}))(CustomButton);
